import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/document/";

export default class DocumentApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getDocuments(params) {
    return await request.post(`${rootRoute}getDocuments`, {
      filter: params,
      parameters: {},
    });
  }
  async getDocument(id) {
    return await request.post(`${rootRoute}getDocuments`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createDocument(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createDocument`, { data });
  }
  async deleteDocument(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteDocument`, { data });
  }
  async editDocument(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateDocument`, { data });
  }
}
